import { Injectable } from '@angular/core';
import { Utilitarios } from '../shared/utilitarios';

@Injectable({
  providedIn: 'root'
})
export class CircuitBreakerService {

  limit: number = 3;
  circuitBreaker: Array<any> = [];

  constructor() { }

  circuitStart(api: string, status: number): boolean{
    var circuits = this.circuitBreaker.filter(function (el) {
      return el.api == api;
    });
    
    if(circuits.length<this.limit){
      this.circuitBreaker.push({api:api,statusCode:status,data: Utilitarios.addMinutes(new Date(), 5)});
    }
    else{
      this.circuitEnd(api);
      return false;
    }

    return true;
  }

  circuitEnd(api: string){
    var circuits = this.circuitBreaker.filter(function (el) {
      return el.api == api;
    });
    
    if(circuits.length==this.limit && new Date() > circuits[this.limit - 1].data){
      this.circuitBreaker = this.circuitBreaker.filter(function (el) {
        return el.api != api;
      });
    }
  }

  circuitReset(){
    this.circuitBreaker = new Array<any>();
  }
}